// Omlijsting van het inlogscherm: logo, ondertitel en meldingen.
import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { motion } from 'framer-motion';
import AuthCardShell from './AuthCardShell';

export default function LoginCard({ theme, view, success, setSuccess, error, setError, children }) {
  return (
    <AuthCardShell
      theme={theme}
      accentGradient={`linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}>
        <motion.div
          whileHover={{ scale: 1.05, rotate: 2 }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              mb: 2,
              borderRadius: 3,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: `0 8px 20px ${theme.palette.primary.main}40`,
              p: 1.5,
            }}
          >
            <Box
              component="img"
              src="/logo192.png"
              alt="BEM.report Logo"
              sx={{
                width: '100%',
                height: '100%',
                borderRadius: 2,
                filter: 'brightness(0) invert(1)',
              }}
            />
          </Box>
        </motion.div>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 'bold',
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 0.5,
          }}
        >
          BEM.report
        </Typography>
        {view !== 'resetSent' && (
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              mt: 0.5,
              fontWeight: 500,
              textAlign: 'center',
            }}
          >
            {view === 'login' ? 'Beveiligde toegang tot jouw projecten' : ''}
          </Typography>
        )}
      </Box>

      {success && view === 'login' && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <Alert
            severity="success"
            sx={{
              mb: 3,
              borderRadius: 2,
              '& .MuiAlert-icon': {
                color: 'success.main',
              },
            }}
            onClose={() => setSuccess(null)}
          >
            {success}
          </Alert>
        </motion.div>
      )}
      {error && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <Alert
            severity="error"
            sx={{
              mb: 3,
              borderRadius: 2,
              '& .MuiAlert-icon': {
                color: 'error.main',
              },
            }}
            onClose={() => setError(null)}
          >
            {error}
          </Alert>
        </motion.div>
      )}

      {children}
    </AuthCardShell>
  );
}
